import React from 'react';

const TechnicalSkills = () => {
  return (
    <section id="skills">
      <div className="section-header animate-fade-in-up">
        <span className="section-number">02.</span>
        <h2 className="section-title">Technical Skills</h2>
        <div className="section-line"></div>
      </div>
      <div className="skills-content">
        <div className="skills-main">
  <div className="skill-category animate-fade-in-left delay-2">
    <h3>Programming Languages & Core CS</h3>
    <ul>
      <li className="animate-fade-in-up delay-3">Python</li>
      <li className="animate-fade-in-up delay-3">Data Structures & Algorithms</li>
      <li className="animate-fade-in-up delay-3">Object-Oriented Programming (OOP)</li>
      <li className="animate-fade-in-up delay-3">Operating Systems</li>
      <li className="animate-fade-in-up delay-3">Database Design</li>
    </ul>
  </div>

  <div className="skill-category animate-fade-in-left delay-2">
    <h3>Software Engineering</h3>
    <ul>
      <li className="animate-fade-in-up delay-3">Software Development Life Cycle (SDLC)</li>
      <li className="animate-fade-in-up delay-3">Unit & Integration Testing</li>
      <li className="animate-fade-in-up delay-3">Code Reviews</li>
      <li className="animate-fade-in-up delay-3">Version Control (Git)</li>
      <li className="animate-fade-in-up delay-3">Problem Solving</li>
    </ul>
  </div>

  <div className="skill-category animate-fade-in-left delay-3">
    <h3>Backend & Databases</h3>
    <ul>
      <li className="animate-fade-in-up delay-4">Flask</li>
      <li className="animate-fade-in-up delay-4">Django</li>
      <li className="animate-fade-in-up delay-4">FastAPI</li>
      <li className="animate-fade-in-up delay-4">REST APIs</li>
      <li className="animate-fade-in-up delay-4">PostgreSQL</li>
      <li className="animate-fade-in-up delay-4">SQLite</li>
      <li className="animate-fade-in-up delay-4">Docker</li>
    </ul>
  </div>

  <div className="skill-category animate-fade-in-left delay-3">
    <h3>AI & Machine Learning</h3>
    <ul>
      <li className="animate-fade-in-up delay-4">Machine Learning (Supervised & Unsupervised)</li>
      <li className="animate-fade-in-up delay-4">Feature Engineering & Model Evaluation</li>
      <li className="animate-fade-in-up delay-4">Deep Learning (CNN, LSTM, Transformers)</li>
      <li className="animate-fade-in-up delay-4">Natural Language Processing (NLP)</li>
    </ul>
  </div>

  <div className="skill-category animate-fade-in-left delay-4">
    <h3>LLMs & RAG</h3>
    <ul>
      <li className="animate-fade-in-up delay-5">Retrieval-Augmented Generation (RAG)</li>
      <li className="animate-fade-in-up delay-5">LangChain</li>
      <li className="animate-fade-in-up delay-5">LangSmith</li>
      <li className="animate-fade-in-up delay-5">LlamaIndex</li>
      <li className="animate-fade-in-up delay-5">Embeddings & Vector Databases</li>
      <li className="animate-fade-in-up delay-5">Prompt Engineering</li>
      <li className="animate-fade-in-up delay-5">Retrieval Pipelines</li>
    </ul>
  </div>

  <div className="skill-category animate-fade-in-left delay-4">
    <h3>Libraries & Frameworks</h3>
    <ul>
      <li className="animate-fade-in-up delay-5">TensorFlow</li>
      <li className="animate-fade-in-up delay-5">Keras</li>
      <li className="animate-fade-in-up delay-5">scikit-learn</li>
      <li className="animate-fade-in-up delay-5">NLTK</li>
      <li className="animate-fade-in-up delay-5">spaCy</li>
      <li className="animate-fade-in-up delay-5">MediaPipe</li>
      <li className="animate-fade-in-up delay-5">OpenCV</li>
    </ul>
  </div>

  <div className="skill-category animate-fade-in-left delay-4">
    <h3>Tools & Platforms</h3>
    <ul>
      <li className="animate-fade-in-up delay-5">Docker</li>
      <li className="animate-fade-in-up delay-5">Google Colab</li>
      <li className="animate-fade-in-up delay-5">Jupyter Notebook</li>
      <li className="animate-fade-in-up delay-5">FFmpeg</li>
    </ul>
  </div>
</div>
<div className="logos-sidebar animate-fade-in-right delay-2">
  {/* Programming & Core */}
  <img src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/python/python-original.svg" alt="Python" className="animate-bounce-slow" />
  <img src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/git/git-original.svg" alt="Git" className="animate-bounce-slow" />
  <img src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/github/github-original.svg" alt="GitHub" className="animate-bounce-slow" />

  {/* Backend */}
  <img src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/flask/flask-original.svg" alt="Flask" className="animate-bounce-slow" />
  <img src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/django/django-plain.svg" alt="Django" className="animate-bounce-slow" />
  <img src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/fastapi/fastapi-original.svg" alt="FastAPI" className="animate-bounce-slow" />

  {/* Databases */}
  <img src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/postgresql/postgresql-original.svg" alt="PostgreSQL" className="animate-bounce-slow" />
  <img src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/sqlite/sqlite-original.svg" alt="SQLite" className="animate-bounce-slow" />

  {/* DevOps */}
  <img src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/docker/docker-original.svg" alt="Docker" className="animate-bounce-slow" />

  {/* AI / ML */}
  <img src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/tensorflow/tensorflow-original.svg" alt="TensorFlow" className="animate-bounce-slow" />
  <img src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/pytorch/pytorch-original.svg" alt="PyTorch" className="animate-bounce-slow" />
  <img src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/opencv/opencv-original.svg" alt="OpenCV" className="animate-bounce-slow" />
  <img src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/scikitlearn/scikitlearn-original.svg" alt="scikit-learn" className="animate-bounce-slow" />

  {/* Tools */}
  <img src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/jupyter/jupyter-original.svg" alt="Jupyter Notebook" className="animate-bounce-slow" />
  <img src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/linux/linux-original.svg" alt="Linux" className="animate-bounce-slow" />
</div>

      </div>
    </section>
  );
};

export default TechnicalSkills;